import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import MultiHome from "./views/MultiHome.vue";
import VueCookie from "vue-cookie";

Vue.use(Router);

export default new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/:lang",
      component: MultiHome,
      beforeEnter(to, from, next) {
        const lang = to.params.lang;
        const idiomas = ["eu", "es", "en", "fr"];
        const idioma = idiomas.includes(lang);
        // console.log('rutas', to.params)
        if (idioma) {
          VueCookie.set("lang", lang);
          next();
        }
      },
      children: [
        {
          path: "",
          name: "inicio",
          component: Home,
        },
        {
          path: "detalle/:cmsID/:idRecinto",
          name: "Detalle",
          props: true,
          beforeEnter: (to, from, next) => {
            if (to.params.cmsID === 'SSIFF24@Janto_KB') {
              // Redirect to external URL
              window.location.href = 'https://sansebastianfestival.janto.es'
            } else {
              // Load the component as usual
              next()
            }
          },

          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Detalle.vue"),
        },
        {
          path: "mis-operaciones",
          name: "Operaciones",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Pagina.vue"),
        },
        {
          path: "como-comprar",
          name: "Comprar",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Comprar.vue"),
        },
        {
          path: "recintos/:id",
          name: "Recintos",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Recintos.vue"),
        },
        {
          path: "ver-recinto/:idRecinto",
          name: "verRecinto",
          props: true,
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(/* webpackChunkName: "about" */ "./components/paginas/verRecintos.vue"),
        },
        {
          path: "recinto/:idRecinto",
          name: "recinto",
          props: true,
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(/* webpackChunkName: "about" */ "./components/paginas/verRecinto.vue"),
        },
        {
          path: "privacidad",
          name: "Privacidad",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Privacidad.vue"),
        },
        {
          path: "cat/:id",
          name: "Categoria",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(/* webpackChunkName: "about" */ "./components/paginas/Categoria.vue"),
        },
        {
          path: "loc/:id",
          name: "Provincia",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(/* webpackChunkName: "about" */ "./components/paginas/Provincia.vue"),
        },
        {
          path: "pag/:id",
          name: "Contenido",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Contenidos.vue"),
        },
        {
          path: "*",
          name: "default",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Home.vue"),
        },
      ],
    },
    // {
    //   path: 'es',
    //   name: 'Castellano',
    //   beforeEnter(to,from,next){
    //     const lang = 'es'
    //     VueCookie.set('lang', lang)
    //     next()
    //   },
    //   component: Home
    // },
    // {
    //   path: '/eu',
    //   name: 'Euskera',
    //   beforeEnter(to,from,next){
    //     const lang = 'eu'
    //     VueCookie.set('lang', lang)
    //     next()
    //   },
    //   component: Home
    // },
    // {
    //   path: '/en',
    //   name: 'English',
    //   beforeEnter(to,from,next){
    //     const lang = 'en'
    //     VueCookie.set('lang', lang)
    //     next()
    //   },
    //   component: Home
    // },
    // {
    //   path: '/fr',
    //   name: 'Frances',
    //   beforeEnter(to,from,next){
    //     const lang = 'fr'
    //     VueCookie.set('lang', lang)
    //     next()
    //   },
    //   component: Home
    // },
    {
      // Redirect user to supported lang version.
      path: "*",
      redirect(to) {
        return "es";
      },
    },
  ],
});
